"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = modal;
var _ModalTypes = require("@studio/constants/ModalTypes");
var _types = require("../../actions/meeting/types");
var _types2 = require("../../actions/modal/types");
/**
 * In cases where you need to show a modal, use this state (no longer want to use one-off reducers like 'creatingEvent', etc)
 */
function modal() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === _types2.SHOW_MODAL) {
    return action.payload;
  }
  if (action.type === _types2.CLEAR_MODAL) {
    if (state && action.payload === state.type) return null;
  }
  if (action.type === "".concat(_types.BROADCAST_CREATE_MEETING, "_FAILURE")) {
    return {
      type: _ModalTypes.CREATE_MEETING_ERROR,
      errorResponse: action.payload.error.response.data
    };
  }
  return state;
}